/**
 * Lim Flex Finance logic

 */
(function () {
  'use strict';

  //  Config
  const root = document.getElementById('lim-flex-finance');
  if (!root) return;

  const API_BASE = root.dataset.apiBase || '';
  const PRODUCT = {
    title: root.dataset.productTitle || '',
    sku: root.dataset.productSku || '',
    basePrice: parseFloat(root.dataset.productPrice) || 0,
    vendor: root.dataset.productVendor || '',
    isNewVehicle: root.dataset.productIsNew === 'true',
    ccm: parseInt(root.dataset.productCcm, 10) || 0,
    url: root.dataset.productUrl || '',
  };

  // Location Dropdown
  var productLocations = [];
  (function initLocations() {
    var raw = root.dataset.productLocations || '';
    if (!raw) return;
    try {
      var parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        productLocations = parsed.map(function (l) { return String(l).trim(); }).filter(Boolean);
      }
    } catch (e) {
      productLocations = raw.split(',').map(function (l) { return l.trim(); }).filter(Boolean);
    }
    if (productLocations.length > 0) {
      var section = document.getElementById('lim-location-section');
      var select = document.getElementById('lim-location');
      if (section && select) {
        productLocations.forEach(function (loc) {
          var opt = document.createElement('option');
          opt.value = loc;
          opt.textContent = loc;
          select.appendChild(opt);
        });
        section.style.display = '';
      }
    }
  })();

  // State
  let currentStep = 1;
  const totalSteps = 4;
  let calculationData = {};
  let selectedInsurances = [];
  let selectedGuarantee = { name: 'Gesetzliche Gewährleistung', price: 0 };
  let baseMonthlyRate = 0;
  let guaranteePrice = 0;
  let csrfToken = null;

   // Util
  function fmt(value) {
    return new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value || 0);
  }

  function setText(id, text) {
    var el = document.getElementById(id);
    if (el) el.textContent = text;
  }

  function setCurrency(id, value) {
    setText(id, fmt(value) + ' \u20AC');
  }

  // CSRF Token
  async function fetchCsrfToken() {
    try {
      var res = await fetch(API_BASE + '/api/csrf/token', { credentials: 'include' });
      var data = await res.json();
      csrfToken = data.csrfToken;
    } catch (err) {
      console.error('Failed to fetch CSRF token:', err);
    }
  }

  // Custom Slider
  function CustomSlider(el) {
    this.el = el;
    this.fill = el.querySelector('.fill');
    this.thumb = el.querySelector('.thumb');
    this.min = parseFloat(el.dataset.min) || 0;
    this.max = parseFloat(el.dataset.max) || 100;
    this.step = parseFloat(el.dataset.step) || 1;
    this.input = document.getElementById(el.dataset.input);
    this.dragging = false;
    this.value = Math.max(
      this.min,
      Math.min(this.max, parseFloat(this.input && this.input.value) || this.min)
    );
    if (this.input) this.input.value = this.value;
    this._init();
  }

  CustomSlider.prototype._init = function () {
    this._updateVisual();
    var self = this;

    this.thumb.addEventListener('mousedown', function (e) {
      e.preventDefault();
      self.dragging = true;
      self.thumb.classList.add('dragging');
    });

    this.el.addEventListener('click', function (e) {
      if (e.target === self.thumb) return;
      self._setValueFromEvent(e);
    });

    document.addEventListener('mousemove', function (e) {
      if (!self.dragging) return;
      e.preventDefault();
      self._setValueFromEvent(e);
    });

    document.addEventListener('mouseup', function () {
      self.dragging = false;
      self.thumb.classList.remove('dragging');
    });

    this.thumb.addEventListener(
      'touchstart',
      function (e) {
        e.preventDefault();
        self.dragging = true;
        self.thumb.classList.add('dragging');
      },
      { passive: false }
    );

    document.addEventListener(
      'touchmove',
      function (e) {
        if (!self.dragging) return;
        e.preventDefault();
        self._setValueFromEvent(e);
      },
      { passive: false }
    );

    document.addEventListener('touchend', function () {
      self.dragging = false;
      self.thumb.classList.remove('dragging');
    });
  };

  CustomSlider.prototype._setValueFromEvent = function (e) {
    var rect = this.el.getBoundingClientRect();
    var clientX = e.touches ? e.touches[0].clientX : e.clientX;
    var pct = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
    var rawValue = this.min + pct * (this.max - this.min);
    var val = Math.round(rawValue / this.step) * this.step;
    val = Math.max(this.min, Math.min(this.max, val));
    if (val !== this.value) {
      this.value = val;
      this._updateVisual();
      if (this.input) this.input.value = val;
      calculate();
    }
  };

  CustomSlider.prototype._updateVisual = function () {
    var range = this.max - this.min;
    var pct = range > 0 ? ((this.value - this.min) / range) * 100 : 0;
    this.fill.style.width = pct + '%';
    this.thumb.style.left = pct + '%';
  };

  // Calc
  function calculate() {
    var K = PRODUCT.basePrice + guaranteePrice;
    var A = parseFloat(document.getElementById('lim-down-payment').value) || 0;
    var n = parseInt(document.getElementById('lim-term').value, 10) || 72;
    var ieff =
      parseFloat(document.getElementById('lim-interest-rate').value) / 100 || 0.0699;
    var RV =
      parseFloat(document.getElementById('lim-residual-value').value) / 100 || 0.5;

    document.getElementById('lim-purchase-price').value = K.toFixed(2);
    if (K <= 0) return;
    var D = K - A;
    if (D < 500) {
      updateResults({
        monthlyRate: 0,
        firstRate: 0,
        netLoan: D,
        finalPayment: 0,
        totalCredit: 0,
        totalInterest: 0,
      });
      return;
    }

    var B = D * RV;
    var p = Math.pow(1 + ieff, 1 / 12) - 1;
    var PVB = B / Math.pow(1 + p, n);
    var P = D - PVB;
    var n1 = n - 1;

    var num = P * p * Math.pow(1 + p, n1);
    var den = Math.pow(1 + p, n1) - 1;
    if (den === 0) return;
    var C = num / den;

    var CR = Math.ceil(C);
    var d = CR - C;
    var n2 = n - 2;

    var PVd =
      p !== 0 && n2 > 0
        ? d * ((Math.pow(1 + p, n2) - 1) / (p * Math.pow(1 + p, n2)))
        : 0;

    var C1 = Math.round((C - PVd) * 100) / 100;
    var totalCredit = Math.round((C1 + CR * n2 + B) * 100) / 100;
    var totalInterest = Math.round((totalCredit - D) * 100) / 100;

    calculationData = {
      purchasePrice: K,
      basePurchasePrice: PRODUCT.basePrice,
      guaranteePrice: guaranteePrice,
      downPayment: A,
      netLoan: D,
      monthlyRate: CR,
      firstRate: C1,
      finalPayment: B,
      totalCredit: totalCredit,
      totalInterest: totalInterest,
      term: n,
      interestRate: ieff * 100,
      residualValuePercent: RV * 100,
    };
    baseMonthlyRate = CR;
    updateResults(calculationData);
    updateGuaranteePanel();
    updateSummary();
  }

  function calculateRateForGuarantee(gPrice) {
    var K = PRODUCT.basePrice + gPrice;
    var A = parseFloat(document.getElementById('lim-down-payment').value) || 0;
    var n = parseInt(document.getElementById('lim-term').value, 10) || 72;
    var ieff =
      parseFloat(document.getElementById('lim-interest-rate').value) / 100 || 0.0699;
    var RV =
      parseFloat(document.getElementById('lim-residual-value').value) / 100 || 0.5;
    var D = K - A;
    if (D < 500) return 0;
    var B = D * RV;
    var p = Math.pow(1 + ieff, 1 / 12) - 1;
    var PVB = B / Math.pow(1 + p, n);
    var P = D - PVB;
    var n1 = n - 1;
    var num = P * p * Math.pow(1 + p, n1);
    var den = Math.pow(1 + p, n1) - 1;
    if (den === 0) return 0;
    return Math.ceil(num / den);
  }

  function updateResults(d) {
    setCurrency('lim-monthly-rate', d.monthlyRate);
    setCurrency('lim-first-rate', d.firstRate);
    setCurrency('lim-net-loan', d.netLoan);
    setCurrency('lim-final-payment', d.finalPayment);
    setCurrency('lim-total-credit', d.totalCredit);
    setCurrency('lim-total-interest', d.totalInterest);
  }

  function updateGuaranteePanel() {
    setCurrency('lim-guarantee-display', guaranteePrice);
    setCurrency('lim-new-monthly-rate', baseMonthlyRate);
    updateCardRates();
  }

  function updateCardRates() {
    var cards = root.querySelectorAll('.guarantee-card');
    cards.forEach(function (card) {
      var cardPrice = parseFloat(card.dataset.price) || 0;
      var rate = calculateRateForGuarantee(cardPrice);
      var rateEl = card.querySelector('.card-rate-value');
      if (rateEl) rateEl.textContent = fmt(rate) + ' \u20AC';
    });
  }

  function updateSummary() {
    setCurrency('summary-purchase-price', calculationData.purchasePrice || PRODUCT.basePrice);
    setCurrency('summary-total', baseMonthlyRate);

    var gEl = document.getElementById('summary-guarantee');
    if (gEl) {
      gEl.textContent =
        guaranteePrice > 0
          ? selectedGuarantee.name + ' (+' + fmt(guaranteePrice) + ' \u20AC)'
          : selectedGuarantee.name;
    }

    var iRow = document.getElementById('summary-insurance-row');
    var iEl = document.getElementById('summary-insurance');
    if (iRow && iEl) {
      if (selectedInsurances.length > 0) {
        iRow.style.display = 'flex';
        iEl.textContent = selectedInsurances.map(function (i) { return i.name; }).join(', ');
      } else {
        iRow.style.display = 'none';
      }
    }
  }

 // Step Nav
  function goToStep(step) {
    if (step < 1 || step > totalSteps) return;

    //Mark current step
    var currentIndicator = root.querySelector('.step-indicator[data-step="' + currentStep + '"]');
    var nextIndicator = root.querySelector('.step-indicator[data-step="' + step + '"]');

    if (step > currentStep) {
      currentIndicator.classList.add('completed');
      currentIndicator.classList.remove('active');
    } else {
      currentIndicator.classList.remove('active');
      // When going back remove completed from all steps >= target
      for (var i = step; i <= totalSteps; i++) {
        var ind = root.querySelector('.step-indicator[data-step="' + i + '"]');
        if (ind) ind.classList.remove('completed');
      }
    }

    nextIndicator.classList.add('active');
    currentStep = step;

    root.querySelectorAll('.step-content').forEach(function (c) {
      c.classList.remove('active');
    });
    root.querySelector('.step-content[data-step="' + step + '"]').classList.add('active');
    root.querySelector('.financing-steps').scrollIntoView({ behavior: 'smooth' });

    if (step === 4) updateSummary();
  }

  function nextStep() {
    if (currentStep < totalSteps) goToStep(currentStep + 1);
  }

  function prevStep() {
    if (currentStep > 1) goToStep(currentStep - 1);
  }

  // Guarantee Selection
  function selectGuarantee(card) {
    root.querySelectorAll('.guarantee-card').forEach(function (c) {
      c.classList.remove('selected');
    });
    card.classList.add('selected');
    guaranteePrice = parseFloat(card.dataset.price) || 0;
    selectedGuarantee = { name: card.dataset.name, price: guaranteePrice };
    calculate();
  }

  // Insurance Toggle
  function toggleInsurance(card) {
    var inp = card.querySelector('.insurance-data');
    var name = inp.dataset.name;
    if (card.classList.contains('selected')) {
      card.classList.remove('selected');
      selectedInsurances = selectedInsurances.filter(function (i) { return i.name !== name; });
    } else {
      card.classList.add('selected');
      selectedInsurances.push({ name: name });
    }
    updateSummary();
  }

  // Results Toggle
  function toggleResults(el) {
    var expandable = el.nextElementSibling;
    var isOpen = expandable.style.display !== 'none';
    expandable.style.display = isOpen ? 'none' : 'block';
    el.classList.toggle('open', !isOpen);
    el.querySelector('.toggle-text').textContent = isOpen
      ? 'Weitere Details'
      : 'Weniger anzeigen';
  }

  // Form Submission
  function showErrors(errors) {
    var errDiv = document.getElementById('lim-form-errors');
    if (!errDiv) return;
    errDiv.innerHTML = '<ul>' + errors.map(function (e) { return '<li>' + e + '</li>'; }).join('') + '</ul>';
    errDiv.classList.add('show');
  }

  function hideErrors() {
    var errDiv = document.getElementById('lim-form-errors');
    if (errDiv) {
      errDiv.classList.remove('show');
      errDiv.innerHTML = '';
    }
  }

  async function submitForm(event) {
    event.preventDefault();
    hideErrors();

    var btn = event.target.querySelector('button[type="submit"]');
    btn.disabled = true;
    btn.textContent = 'Wird gesendet...';

    // Fetch fresh token
    await fetchCsrfToken();
    if (!csrfToken) {
      showErrors(['Sicherheitstoken konnte nicht geladen werden. Bitte laden Sie die Seite neu.']);
      btn.disabled = false;
      btn.textContent = 'Anfrage absenden';
      return;
    }

    var payload = {
      customer: {
        salutation: document.getElementById('lim-salutation').value,
        title: document.getElementById('lim-title').value || '',
        firstName: document.getElementById('lim-first-name').value,
        lastName: document.getElementById('lim-last-name').value,
        email: document.getElementById('lim-email').value,
        phone: document.getElementById('lim-phone').value || '',
        street: document.getElementById('lim-street').value,
        zip: document.getElementById('lim-zip').value,
        city: document.getElementById('lim-city').value,
      },
      financing: {
        purchasePrice: calculationData.purchasePrice,
        basePurchasePrice: calculationData.basePurchasePrice,
        guaranteePrice: calculationData.guaranteePrice,
        downPayment: calculationData.downPayment,
        netLoan: calculationData.netLoan,
        term: calculationData.term,
        interestRate: calculationData.interestRate,
        residualValuePercent: calculationData.residualValuePercent,
        monthlyRate: calculationData.monthlyRate,
        firstRate: calculationData.firstRate,
        finalPayment: calculationData.finalPayment,
        totalCredit: calculationData.totalCredit,
        totalInterest: calculationData.totalInterest,
      },
      product: {
        title: PRODUCT.title,
        sku: PRODUCT.sku,
        vendor: PRODUCT.vendor,
        url: PRODUCT.url,
        ccm: PRODUCT.ccm,
        isNew: PRODUCT.isNewVehicle,
      },
      guarantee: {
        name: selectedGuarantee.name,
        price: selectedGuarantee.price,
      },
      insurances: selectedInsurances.map(function (i) { return i.name; }),
      location: document.getElementById('lim-location')
        ? document.getElementById('lim-location').value
        : '',
      // Honeypot
      website: document.getElementById('lim-hp-website')
        ? document.getElementById('lim-hp-website').value
        : '',
    };

    try {
      var res = await fetch(API_BASE + '/api/finance/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken,
        },
        credentials: 'include',
        body: JSON.stringify(payload),
      });

      var data = await res.json();

      if (!res.ok) {
        var errors = data.details || [data.error || 'Ein Fehler ist aufgetreten.'];
        showErrors(errors);
        btn.disabled = false;
        btn.textContent = 'Anfrage absenden';
        return;
      }

      showSuccess();
    } catch (err) {
      showErrors(['Netzwerkfehler. Bitte prüfen Sie Ihre Verbindung und versuchen es erneut.']);
      btn.disabled = false;
      btn.textContent = 'Anfrage absenden';
    }
  }

  function showSuccess() {
    root.querySelectorAll('.step-content').forEach(function (c) {
      c.classList.remove('active');
    });
    document.getElementById('lim-success-message').classList.add('show');
    var lastIndicator = root.querySelector('.step-indicator[data-step="' + totalSteps + '"]');
    lastIndicator.classList.add('completed');
    lastIndicator.classList.remove('active');
    root.querySelector('.financing-steps').scrollIntoView({ behavior: 'smooth' });
  }

  function init() {
    // Init sliders
    root.querySelectorAll('.lim-custom-slider').forEach(function (el) {
      new CustomSlider(el);
    });

    // Term dropdown
    var termSelect = document.getElementById('lim-term');
    if (termSelect) {
      termSelect.addEventListener('change', calculate);
    }

    // Next/Prev buttons
    root.querySelectorAll('[data-action="next-step"]').forEach(function (btn) {
      btn.addEventListener('click', nextStep);
    });

    root.querySelectorAll('[data-action="prev-step"]').forEach(function (btn) {
      btn.addEventListener('click', prevStep);
    });

    // Results toggle
    root.querySelectorAll('.results-toggle').forEach(function (el) {
      el.addEventListener('click', function () {
        toggleResults(el);
      });
    });

    // Guarantee cards
    root.querySelectorAll('.guarantee-card').forEach(function (card) {
      card.addEventListener('click', function () {
        selectGuarantee(card);
      });
    });

    // Insurance cards
    root.querySelectorAll('.insurance-card').forEach(function (card) {
      card.addEventListener('click', function () {
        toggleInsurance(card);
      });
    });

    // Form submission
    var form = document.getElementById('lim-financing-form');
    if (form) {
      form.addEventListener('submit', submitForm);
    }

    // Init calculation
    calculate();

    // Pre-fetch CSRF token
    fetchCsrfToken();
  }

  // Bootstrap
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
